import { Input } from '../ui/Input.tsx';

// ─── Types & constants ────────────────────────────────────────────────────────

export interface EventFormValues {
  name: string;
  description: string;
  startsAt: string;
  endsAt: string;
  locationName: string;
  locationAddress: string;
  maxCapacity: string;
  registrationDeadline: string;
  imageUrl: string;
}

export const EMPTY_EVENT_FORM: EventFormValues = {
  name: '',
  description: '',
  startsAt: '',
  endsAt: '',
  locationName: '',
  locationAddress: '',
  maxCapacity: '',
  registrationDeadline: '',
  imageUrl: '',
};

export function toLocalDatetimeValue(isoStr: string | null | undefined): string {
  if (!isoStr) return '';
  const d = new Date(isoStr);
  if (isNaN(d.getTime())) return '';
  const offset = d.getTimezoneOffset() * 60_000;
  const local = new Date(d.getTime() - offset);
  return local.toISOString().slice(0, 16);
}

// ─── Component ────────────────────────────────────────────────────────────────

interface EventFormFieldsProps {
  values: EventFormValues;
  onChange: (key: keyof EventFormValues, value: string) => void;
}

export function EventFormFields({ values, onChange }: EventFormFieldsProps) {
  return (
    <>
      <Input
        label="Name *"
        value={values.name}
        onChange={(e) => onChange('name', e.target.value)}
        placeholder="Event name"
      />

      <div>
        <label className="block text-xs font-medium text-zinc-600 mb-1">Description</label>
        <textarea
          value={values.description}
          onChange={(e) => onChange('description', e.target.value)}
          rows={3}
          placeholder="Optional description"
          className="w-full text-sm border border-zinc-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-zinc-300 resize-none"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Input
          label="Start date *"
          type="datetime-local"
          value={values.startsAt}
          onChange={(e) => onChange('startsAt', e.target.value)}
        />
        <Input
          label="End date"
          type="datetime-local"
          value={values.endsAt}
          onChange={(e) => onChange('endsAt', e.target.value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Input
          label="Location"
          value={values.locationName}
          onChange={(e) => onChange('locationName', e.target.value)}
          placeholder="Location name"
        />
        <Input
          label="Address"
          value={values.locationAddress}
          onChange={(e) => onChange('locationAddress', e.target.value)}
          placeholder="Full address"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Input
          label="Max capacity"
          type="number"
          min="0"
          value={values.maxCapacity}
          onChange={(e) => onChange('maxCapacity', e.target.value)}
          placeholder="Unlimited if empty"
        />
        <Input
          label="Registration deadline"
          type="datetime-local"
          value={values.registrationDeadline}
          onChange={(e) => onChange('registrationDeadline', e.target.value)}
        />
      </div>

      <Input
        label="Image URL"
        value={values.imageUrl}
        onChange={(e) => onChange('imageUrl', e.target.value)}
        placeholder="https://..."
      />
    </>
  );
}
